"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeService = void 0;
var tslib_1 = require("tslib");
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var startupTime = new Date();
var TimeService = /** @class */ (function () {
    function TimeService() {
        this.clientTime = startupTime.getTime();
        this.serverTime = startupTime.getTime();
    }
    TimeService.prototype.update = function (serverNow) {
        this.clientTime = new Date().getTime();
        this.serverTime = new Date(serverNow).getTime();
        console.log("update time");
    };
    TimeService.prototype.serverNow = function () {
        var now = new Date().getTime();
        return this.serverTime + now - this.clientTime;
    };
    TimeService.diOptions = di_1.default.options({
        name: "timeService",
    });
    return TimeService;
}());
exports.TimeService = TimeService;
